import {
  getAttributeList,
  initQueryParams,
  makeDatesQueryParams,
  makeSearchQueryParams,
  makeQueryParam$instr,
} from '@/business/apiTreatment/request/queryParamsUtils';
import {
  MakeListRequestOpts,
  ListRequestOpts,
} from '@/business/apiTreatment/request/makeQueryParams';
import { OrdsQueryParams } from '@/business/apiTreatment/request/reusableBaseRequest';

const DEFAULT_ITEMS_REQUEST = 500;
const serverSideAttributeKeys = [
  'work_order_group_qualif_code',
  'work_order_group_type_code',
  'reason_id',
];

/**
 * Business function. make query newItem function for API call.
 * @param {array} searchAttributesArray the attributes to search in
 * @param {boolean} useEntities
 * @returns {function({search?: *, page?: *, pageSize?: *, entities?: *, sort: *, sortBy: *, attributesObj: *, serverSideAttributeKeys: *}): {limit: (*|number)}} The makeQueryParams function.
 */
function makeListRequest({
  limitItemsRequest,
  useEntities,
  navFullIdField = 'entity_nav_full_id',
  dateField,
  dateNullable,
  customFunc,
}: MakeListRequestOpts) {
  return ({
    search,
    page,
    pageSize,
    entities,
    sort,
    sortBy,
    attributesObj,
    dateMin,
    dateMax,
  }: ListRequestOpts): OrdsQueryParams => {
    const AndQueryParams = [];
    const queryParams = initQueryParams({
      limitItemsRequest,
      pageSize: pageSize || DEFAULT_ITEMS_REQUEST,
      page,
      sort,
      sortBy,
      useEntities,
      entities,
      navFullIdField,
      AndQueryParams,
    });

    if (attributesObj.nature.values.length > 0) {
      const natureFilters = [];
      attributesObj.nature.values.forEach((nature) => {
        if (nature === 'DI') {
          if (serverSideAttributeKeys.length > 0) {
            const andAttributeFilterParams: Object[] = [
              { nature: { $eq: 'DI' } },
            ];
            serverSideAttributeKeys.forEach((attribute) => {
              const orFilters = attributesObj[attribute].values.map((val) => {
                return {
                  [attribute]: { $eq: `${val}` },
                };
              });
              if (orFilters.length > 0) {
                andAttributeFilterParams.push({
                  $or: orFilters,
                });
              }
            });
            if (andAttributeFilterParams.length > 0) {
              natureFilters.push({
                $and: andAttributeFilterParams,
              });
            }
          }
        } else {
          natureFilters.push({ nature: { $eq: nature } });
        }
      });
      if (natureFilters.length > 0) {
        AndQueryParams.push({
          $or: natureFilters,
        });
      }
    }

    AndQueryParams.push({ ventilation_affected: { $eq: 'N' } });

    makeSearchQueryParams(search, AndQueryParams);
    makeDatesQueryParams(
      dateField,
      dateNullable,
      dateMin,
      AndQueryParams,
      dateMax
    );

    getAttributeList(attributesObj, '$instr').forEach(
      makeQueryParam$instr(attributesObj, AndQueryParams)
    );

    if (customFunc) {
      customFunc(AndQueryParams);
    }

    if (AndQueryParams.length > 0) {
      queryParams.q = {
        ...queryParams.q,
        $and: AndQueryParams,
      };
    }
    return queryParams;
  };
}

export { makeListRequest, DEFAULT_ITEMS_REQUEST };
export default makeListRequest;
